module.exports = __webpack_public_path__ + "static/img/member09.53ec8b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member09.png
// module id = MIOy
// module chunks = 0